import React, { useState, useEffect } from "react";
import {
  isValidAadhaarNumber,
  isValidGstNumber,
  isValidPanNumber,
  openSignUrl,
} from "../../../utils/HelperFunction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UploadFileToS3 } from "../../../utils/S3File";
import httpRequest from "../../../utils/Http";
import { Link } from "react-router-dom";
import { ONLY_RM_ASM_ACTION_PERMISSION } from "../../../constant/action_permission";

export default function UpdateSfDocuments({ sfdetails, SetSfDetails, roleId }) {
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  let fd = {
    sf_id: sfdetails.id,
    pan_number: sfdetails.pan_number,
    aadhar_number: sfdetails.aadhar_number,
  };

  if (sfdetails.gst_details !== null) {
    fd = {
      ...fd,
      gst_number: sfdetails.gst_details.gst_number,
      gst_id: sfdetails.gst_details.id,
    };
  }

  const [formData, setFormData] = useState(fd);

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.pan_number) {
      errors.pan_number = "Pan Number is Required";
    } else {
      if (!value.pan_file && value.pan_number !== sfdetails.pan_number) {
        errors.pan_file = "Pan File is Required (Only Image & PDF file)";
      }

      if (!isValidPanNumber(value.pan_number)) {
        errors.pan_number = "Pan Number is not valid";
      }
    }

    if (value.gst_number) {
      if (
        sfdetails.gst_details !== null &&
        !value.gst_file &&
        value.gst_number !== sfdetails.gst_details.gst_number
      ) {
        errors.gst_file = "GST File is Required (Only Image & PDF file)";
      } else if (!value.gst_file && sfdetails.gst_details === null) {
        errors.gst_file = "GST File is Required (Only Image & PDF file)";
      }

      if (!isValidGstNumber(value.gst_number)) {
        errors.gst_number = "GST Number is not valid";
      }

      // const state = Number(value.gst_number.slice(0, 2));
      // console.log(sfdetails);
      // if (state !== Number(sfdetails.state.state_code)) {
      //   errors.gst_number =
      //     "GST Number is not valid. State code is not matching";
      // }
    }

    if (value.aadhar_number) {
      if (
        !value.aadhar_file &&
        value.aadhar_number !== sfdetails.aadhar_number
      ) {
        errors.aadhar_file = "Aadhar File is Required (Only Image & PDF file)";
      }

      // if (!isValidAadhaarNumber(value.aadhar_number)) {
      //   errors.aadhar_number = "Aadhar Number is not valid";
      // }
    }

    if (
      sfdetails.gst_details !== null &&
      value.pan_number == sfdetails.pan_number &&
      value.aadhar_number == sfdetails.aadhar_number &&
      value.gst_number == sfdetails.gst_details.gst_number &&
      !value.pan_file &&
      !value.gst_file &&
      !value.aadhar_file
    ) {
      errors.mandatory = "There is no change in the existing data.";
    }
    console.log(errors);
    return errors;
  };
  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        let formData1 = {};
        formData1.sf_id = formData.sf_id;
        if (formData.gst_id) {
          formData1.gst_id = formData.gst_id;
        }
        if (formData.pan_number) {
          formData1.pan_number = formData.pan_number;
        }
        console.log(formData.pan_file);
        if (formData.pan_file) {
          const panfile = await UploadFileToS3("docFile", formData.pan_file);
          formData1.pan_file = panfile;
        } else {
          formData1.pan_file = sfdetails.pan_file;
        }

        if (formData.aadhar_number) {
          formData1.aadhar_number = formData.aadhar_number;

          if (formData.aadhar_file) {
            const aadharfile = await UploadFileToS3(
              "docFile",
              formData.aadhar_file,
            );
            formData1.aadhar_file = aadharfile;
          } else {
            formData1.aadhar_file = sfdetails.aadhar_file;
          }
        }

        if (formData.gst_number) {
          formData1.gst_number = formData.gst_number;
          formData1.pincode = sfdetails.pincode;
          formData1.city = sfdetails.city;
          formData1.state_id = sfdetails.state_id;

          if (formData.gst_file) {
            const gstfile = await UploadFileToS3("docFile", formData.gst_file);
            formData1.gst_file = gstfile;
          }

          if (!formData.gst_file) {
            formData1.gst_file = sfdetails.gst_details?.gst_file || "";
          }
        }

        document.getElementById("updateSFDocuments").reset();

        console.log(formData);
        const data = await httpRequest("updatesfdocuments", formData1, "POST");

        setSubmit(false);
        if (data.status === true && data.message) {
          SetSfDetails(data.data);
          toast.success(data.message);
          // navigate("/sfdetails/" + data.data["id"] + "?tab=documents");
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    //console.log(formData);
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <form
            id="updateSFDocuments"
            onSubmit={onSubmitHandler}
            encType="multipart/form-data"
            className="form-horizontal documents-form"
          >
            <div className="documents-section">
              <div className="form-group row">
                <label htmlFor="gst_number" className="col-sm-3 col-form-label">
                  GST Number <span className="text-danger">*</span>
                </label>
                <div className="col-sm-7">
                  <input
                    type="text"
                    className={`form-control text-uppercase ${formErrors.gst_number ? "is-invalid" : ""}`}
                    id="gst_number"
                    placeholder="Enter GST number"
                    defaultValue={formData.gst_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        gst_number: e.target.value,
                      });
                    }}
                  />
                  {formErrors.gst_number && (
                    <div className="invalid-feedback d-block">
                      {formErrors.gst_number}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="gst_file" className="col-sm-3 col-form-label">
                  GST File
                </label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    className={`form-control ${formErrors.gst_file ? "is-invalid" : ""}`}
                    id="gst_file"
                    accept=".PDF, .pdf, .png, .PNG, .jpg, .JPG, .jpeg, .JPEG"
                    onChange={(e) => {
                      var files = e.target.files;
                      if (files && files[0]) {
                        var file_name = e.target.files[0]["name"];
                        const regex = new RegExp("(.*?)(pdf|png|jpg|jpeg)$");
                        if (!regex.test(file_name.toLowerCase())) {
                          setFormErrors({
                            gst_file:
                              "GST File is Required (Only PDF & Image file)",
                          });
                        } else {
                          setFormData({
                            ...formData,
                            gst_file: e.target.files[0],
                          });
                        }
                      } else {
                        setFormErrors({
                          ...formErrors,
                          gst_file:
                            "GST File is Required (Only PDF & Image) file allow",
                        });
                      }
                    }}
                  />
                  {formErrors.gst_file && (
                    <div className="invalid-feedback d-block">
                      {formErrors.gst_file}
                    </div>
                  )}
                  {sfdetails.gst_details?.gst_file && (
                    <Link
                      to={"javascript:void(0)"}
                      className="btn btn-sm btn-light mt-2"
                      onClick={() =>
                        openSignUrl(sfdetails.gst_details.gst_file)
                      }
                    >
                      <i className="fas fa-eye"></i> View File
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <hr className="document-divider" />

            <div className="documents-section">
              <div className="form-group row">
                <label htmlFor="pan_number" className="col-sm-3 col-form-label">
                  PAN Number <span className="text-danger">*</span>
                </label>
                <div className="col-sm-7">
                  <input
                    type="text"
                    className={`form-control text-uppercase ${formErrors.pan_number ? "is-invalid" : ""}`}
                    id="pan_number"
                    placeholder="Enter PAN number"
                    defaultValue={formData.pan_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        pan_number: e.target.value,
                      });
                    }}
                  />
                  {formErrors.pan_number && (
                    <div className="invalid-feedback d-block">
                      {formErrors.pan_number}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label htmlFor="pan_file" className="col-sm-3 col-form-label">
                  PAN File <span className="text-danger">*</span>
                </label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    className={`form-control ${formErrors.pan_file ? "is-invalid" : ""}`}
                    id="pan_file"
                    accept=".PDF, .pdf, .png, .PNG, .jpg, .JPG, .jpeg, .JPEG"
                    onChange={(e) => {
                      var files = e.target.files;
                      if (files && files[0]) {
                        var file_name = e.target.files[0]["name"];
                        const regex = new RegExp(
                          "(.*?)(PDF|pdf|png|PNG|jpg|JPG|jpeg|JPEG)$",
                        );
                        if (!regex.test(file_name.toLowerCase())) {
                          setFormErrors({
                            pan_file:
                              "PAN File is Required (Only PDF & Image file)",
                          });
                        } else {
                          setFormData({
                            ...formData,
                            pan_file: e.target.files[0],
                          });
                        }
                      } else {
                        setFormErrors({
                          ...formErrors,
                          pan_file:
                            "PAN File is Required (Only PDF & Image) file allow",
                        });
                      }
                    }}
                  />
                  {formErrors.pan_file && (
                    <div className="invalid-feedback d-block">
                      {formErrors.pan_file}
                    </div>
                  )}
                  {sfdetails.pan_file && (
                    <Link
                      to={"javascript:void(0)"}
                      className="btn btn-sm btn-light mt-2"
                      onClick={() => openSignUrl(sfdetails.pan_file)}
                    >
                      <i className="fas fa-eye"></i> View File
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <hr className="document-divider" />

            <div className="documents-section">
              <div className="form-group row">
                <label
                  htmlFor="aadhar_number"
                  className="col-sm-3 col-form-label"
                >
                  Aadhar Number
                </label>
                <div className="col-sm-7">
                  <input
                    type="text"
                    className={`form-control text-uppercase ${formErrors.aadhar_number ? "is-invalid" : ""}`}
                    id="aadhar_number"
                    placeholder="Enter Aadhar number"
                    defaultValue={formData.aadhar_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        aadhar_number: e.target.value,
                      });
                    }}
                  />
                  {formErrors.aadhar_number && (
                    <div className="invalid-feedback d-block">
                      {formErrors.aadhar_number}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="aadhar_file"
                  className="col-sm-3 col-form-label"
                >
                  Aadhar File
                </label>
                <div className="col-sm-7">
                  <input
                    type="file"
                    className={`form-control ${formErrors.aadhar_file ? "is-invalid" : ""}`}
                    id="aadhar_file"
                    accept=".PDF, .pdf, .png, .PNG, .jpg, .JPG, .jpeg, .JPEG"
                    onChange={(e) => {
                      var files = e.target.files;
                      if (files && files[0]) {
                        var file_name = e.target.files[0]["name"];
                        const regex = new RegExp("(.*?)(pdf|png|jpg|jpeg)$");
                        if (!regex.test(file_name.toLowerCase())) {
                          setFormErrors({
                            aadhar_file:
                              "Aadhar File is Required (Only PDF & Image file)",
                          });
                        } else {
                          setFormData({
                            ...formData,
                            aadhar_file: e.target.files[0],
                          });
                        }
                      } else {
                        setFormErrors({
                          ...formErrors,
                          aadhar_file:
                            "Aadhar File is Required (Only PDF & Image) file allow",
                        });
                      }
                    }}
                  />
                  {formErrors.aadhar_file && (
                    <div className="invalid-feedback d-block">
                      {formErrors.aadhar_file}
                    </div>
                  )}
                  {sfdetails.aadhar_file && (
                    <Link
                      to={"javascript:void(0)"}
                      className="btn btn-sm btn-light mt-2"
                      onClick={() => openSignUrl(sfdetails.aadhar_file)}
                    >
                      <i className="fas fa-eye"></i> View File
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
              <div className="form-group row mt-4">
                <div className="col-sm-10 offset-sm-3">
                  {formErrors.mandatory && (
                    <div className="alert alert-danger alert-sm mb-2">
                      <i className="fas fa-exclamation-circle"></i>{" "}
                      {formErrors.mandatory}
                    </div>
                  )}
                  <button type="submit" className="btn btn-primary">
                    <i className="fas fa-save"></i> Save Documents
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </section>
    </>
  );
}
